"use client";

import { ChatSidebar } from "@/components/chat-sidebar";
import { Button } from "@/components/ui/button";
import { PanelLeft } from "lucide-react";
import type { User } from "next-auth";

interface ChatSidebarToggleProps {
    user: User | undefined;
}

export function ChatSidebarToggle({ user }: ChatSidebarToggleProps) {
    const trigger = (
        <Button
            variant="outline"
            data-tour-id="chat-sidebar-toggle"
            className="bg-white dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800/50 hover:bg-blue-50 dark:hover:bg-blue-800/40"
            title="Chat History"
        >
            <PanelLeft size={16} />
        </Button>
    );

    return <ChatSidebar user={user} trigger={trigger} />;
}
